import { PostEditorState } from '../../../models/post-editor';

export const getUploadingMediaCount = (postGroups: PostEditorState['postGroups']): number =>
  postGroups.reduce((prev, curr) => {
    if (curr.deleted) return prev;
    const currentGroupMedia = curr.groupPostAttributes.content.media.filter(m => m.loading).length;
    const currentPostsMedia = curr.posts.reduce(
      (prevPost, currPost) => currPost.content.media.filter(m => m.loading).length + prevPost,
      0
    );
    return prev + currentGroupMedia + currentPostsMedia;
  }, 0);
